import styles from './styles.module.css';
import {
  ComponentPropsWithRef,
  forwardRef,
  ForwardRefRenderFunction,
} from 'react';
interface IButton extends ComponentPropsWithRef<'button'> {
  text?: string | undefined;
  icon?: string | undefined;
  color?: 'primary' | 'flat' | 'danger' | 'success' | undefined;
  isLoading?: boolean;
  disabled?: boolean;
  isModal?: boolean;
}

export const ButtonBase: ForwardRefRenderFunction<
  HTMLButtonElement,
  IButton
> = ({ text, icon, isLoading, disabled, color, isModal, ...rest }, ref) => {
  return (
    <>
      <button
        disabled={disabled ? disabled : false}
        className={`${styles.btn} justify-content-center ${
          color === 'primary' ? styles.btnPrimary : ''
        } ${color === 'flat' ? styles.btnFlat : ''} ${color === 'success' ? styles.btnSuccess : ''} ${
          color === 'danger' ? styles.btnDanger : ''
        } ${isModal ? 'btn-agree-modal' : ''}`}
        {...rest}
        ref={ref}
      >
        {isLoading ? (
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <i className={`material-icons-outlined ${text ? 'me-2' : ''}`}>
            {icon}
          </i>
        )}
        {text && <span className={styles.span}>{text}</span>}
      </button>
    </>
  );
};

export const Button = forwardRef(ButtonBase);
